/* ============================================
   M-BUR CANDLE CO - COMPLETE ECOMMERCE TRACKER
   70+ Events Tracked
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  const CONFIG = {
    WEBHOOK_URL: 'https://script.google.com/macros/s/AKfycbwdWn5qyUl2cN8nSsjo16q1577T9R6Kc76sX-G78nafzPfnZDJbJcoFP3GHrAFK8128ug/exec',
    DEBUG: false,
    STORAGE_PREFIX: 'mbur_'
  };

  // ============================================
  // UTILITY FUNCTIONS
  // ============================================

  function log(msg, data) {
    if (CONFIG.DEBUG) console.log('[MburTracker]', msg, data || '');
  }

  function generateId() {
    return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
  }

  function getVisitorId() {
    let id = localStorage.getItem(CONFIG.STORAGE_PREFIX + 'visitor_id');
    if (!id) {
      id = 'v_' + generateId();
      localStorage.setItem(CONFIG.STORAGE_PREFIX + 'visitor_id', id);
    }
    return id;
  }

  function getSessionId() {
    let id = sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'session_id');
    if (!id) {
      id = 's_' + generateId();
      sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'session_id', id);
    }
    return id;
  }

  function isReturningVisitor() {
    let isReturn = sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'is_return');
    if (isReturn === null) {
      const lastVisit = localStorage.getItem(CONFIG.STORAGE_PREFIX + 'last_visit');
      isReturn = !!lastVisit ? 'true' : 'false';
      sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'is_return', isReturn);
      localStorage.setItem(CONFIG.STORAGE_PREFIX + 'last_visit', Date.now().toString());
    }
    return isReturn === 'true';
  }

  function getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      gclid: params.get('gclid') || '',
      fbclid: params.get('fbclid') || ''
    };
  }

  function getPageType() {
    const path = window.location.pathname;
    if (path === '/') return 'home';
    if (path.includes('/products/')) return 'product';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/blogs/')) return 'blog';
    if (path.includes('/cart')) return 'cart';
    if (path.includes('/checkout')) return 'checkout';
    if (path.includes('/pages/')) return 'page';
    if (path.includes('/search')) return 'search';
    if (path.includes('/account')) return 'account';
    return 'other';
  }

  function getProductInfo() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      const p = window.ShopifyAnalytics.meta.product;
      return {
        product_name: p.title || '',
        product_id: p.id || '',
        product_price: p.variants && p.variants[0] ? p.variants[0].price : '',
        product_collection: p.type || '',
        product_vendor: p.vendor || ''
      };
    }
    const title = document.querySelector('meta[property="og:title"]');
    const price = document.querySelector('meta[property="product:price:amount"]');
    return {
      product_name: title ? title.content : document.title,
      product_price: price ? price.content : '',
      product_collection: ''
    };
  }

  function getDeviceType() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('mobile') || ua.includes('iphone') || ua.includes('android')) {
      return 'Mobile';
    } else if (ua.includes('tablet') || ua.includes('ipad')) {
      return 'Tablet';
    }
    return 'Desktop';
  }

  function getScreenInfo() {
    return {
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight
    };
  }

  function incrementPageCount() {
    var count = parseInt(sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'page_count') || '0');
    sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'page_count', (count + 1).toString());
    return count + 1;
  }

  // ============================================
  // BLOCK INTERNAL TRAFFIC
  // ============================================

  function isInternalTraffic() {
    const blockedPatterns = [
      '/admin',
      'myshopify.com/admin',
      'shopify.com',
      'editor',
      'preview_theme_id',
      'design_mode'
    ];

    const url = window.location.href.toLowerCase();
    const referrer = document.referrer.toLowerCase();

    for (let i = 0; i < blockedPatterns.length; i++) {
      if (url.includes(blockedPatterns[i]) || referrer.includes(blockedPatterns[i])) {
        return true;
      }
    }

    if (window.Shopify && window.Shopify.designMode) {
      return true;
    }

    return false;
  }

  // ============================================
  // SEND EVENT
  // ============================================

  function sendEvent(eventType, extraData = {}) {
    if (isInternalTraffic()) {
      log('Blocked internal traffic');
      return;
    }

    const utm = getUTMParams();
    const screen = getScreenInfo();

    const payload = {
      timestamp: new Date().toISOString(),
      event_type: eventType,
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: getPageType(),
      referrer: document.referrer,
      user_agent: navigator.userAgent,
      device_type: getDeviceType(),
      screen_width: screen.screen_width,
      screen_height: screen.screen_height,
      viewport_width: screen.viewport_width,
      viewport_height: screen.viewport_height,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_term: utm.utm_term,
      utm_content: utm.utm_content,
      gclid: utm.gclid,
      fbclid: utm.fbclid,
      return_visitor: isReturningVisitor(),
      ...extraData
    };

    log('Sending:', payload);

    if (navigator.sendBeacon) {
      navigator.sendBeacon(CONFIG.WEBHOOK_URL, JSON.stringify(payload));
    } else {
      fetch(CONFIG.WEBHOOK_URL, {
        method: 'POST',
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(() => {});
    }
  }

  // ============================================
  // CORE EVENTS
  // ============================================

  function trackSessionStart() {
    const sessionStarted = sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'session_started');
    if (!sessionStarted) {
      sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'session_started', 'true');
      sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'session_start_time', Date.now().toString());
      sendEvent('session_start', {
        landing_page: window.location.href
      });
    }
  }

  function trackPageView() {
    const pageCount = incrementPageCount();
    sendEvent('page_view', {
      page_number: pageCount
    });
  }

  function trackProductView() {
    if (getPageType() === 'product') {
      const info = getProductInfo();
      sendEvent('product_view', info);
    }
  }

  function trackCollectionView() {
    if (getPageType() === 'collection') {
      const path = window.location.pathname;
      const collection = path.split('/collections/')[1]?.split('/')[0] || '';
      const productCount = document.querySelectorAll('.product-card, .product-item, [data-product-card]').length;
      sendEvent('collection_view', {
        collection_name: collection,
        product_count: productCount
      });
    }
  }

  function trackBlogRead() {
    if (getPageType() === 'blog') {
      const articleTitle = document.querySelector('h1, .article-title, .blog-title');
      sendEvent('blog_read', {
        article_title: articleTitle ? articleTitle.textContent.trim() : document.title
      });
    }
  }

  function trackCartView() {
    if (getPageType() === 'cart') {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          sendEvent('cart_view', {
            cart_value: (cart.total_price / 100).toFixed(2),
            cart_item_count: cart.item_count
          });
        })
        .catch(() => {
          sendEvent('cart_view');
        });
    }
  }

  function trackCheckoutInitiated() {
    if (getPageType() === 'checkout') {
      const checkoutTracked = sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'checkout_tracked');
      if (!checkoutTracked) {
        sessionStorage.setItem(CONFIG.STORAGE_PREFIX + 'checkout_tracked', 'true');
        sendEvent('checkout_initiated');
      }
    }
  }

  function track404Page() {
    // Shopify sets these on true 404 pages
    const is404 =
      window.location.pathname.includes('/404') ||
      document.body.classList.contains('template-404') ||
      document.querySelector('[data-template="404"]') ||
      (typeof Shopify !== 'undefined' && Shopify.designMode === false &&
       document.querySelector('.errors, .not-found, [class*="404"]'));

    if (is404) {
      sendEvent('404_page', {
        attempted_url: window.location.href,
        path: window.location.pathname,
        referrer: document.referrer || 'direct'
      });
    }
  }

  // ============================================
  // ADD TO CART + VISITOR ID TO CART
  // ============================================

  function setupAddToCartTracking() {
    function addVisitorToCart() {
      var visitorId = getVisitorId();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'visitor_id': visitorId }
        })
      }).catch(function() {});
    }

    function getCartAndTrack(productInfo) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          // Build cart items list
          var cartItems = cart.items.map(function(item) {
            return item.title + ' x' + item.quantity;
          }).join(', ');

          sendEvent('add_to_cart', {
            product_name: productInfo.product_name || '',
            product_id: productInfo.product_id || '',
            product_price: productInfo.product_price || '',
            variant_id: productInfo.variant_id || '',
            variant_title: productInfo.variant_title || '',
            quantity_added: productInfo.quantity || 1,
            cart_value: (cart.total_price / 100).toFixed(2),
            cart_item_count: cart.item_count,
            cart_items: cartItems
          });

          addVisitorToCart();
        })
        .catch(function() {
          // Fallback if cart fetch fails
          sendEvent('add_to_cart', productInfo);
          addVisitorToCart();
        });
    }

    // Track form submissions
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        var productInfo = getProductInfo();

        // Get quantity from form
        var qtyInput = form.querySelector('input[name="quantity"]');
        productInfo.quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        // Get variant from form
        var variantInput = form.querySelector('input[name="id"], select[name="id"]');
        if (variantInput) {
          productInfo.variant_id = variantInput.value;
        }

        setTimeout(function() {
          getCartAndTrack(productInfo);
        }, 500);
      }
    });

    // Track fetch-based adds (AJAX)
    var origFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.includes('/cart/add')) {
        var productInfo = getProductInfo();

        // Parse the request body for variant and quantity
        if (options && options.body) {
          try {
            var body = JSON.parse(options.body);
            productInfo.variant_id = body.id || body.items?.[0]?.id || '';
            productInfo.quantity = body.quantity || body.items?.[0]?.quantity || 1;
          } catch (e) {}
        }

        setTimeout(function() {
          getCartAndTrack(productInfo);
        }, 500);
      }

      // Track cart changes
      if (typeof url === 'string' && url.includes('/cart/change')) {
        setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var cartItems = cart.items.map(function(item) {
                return item.title + ' x' + item.quantity;
              }).join(', ');

              sendEvent('cart_updated', {
                cart_value: (cart.total_price / 100).toFixed(2),
                cart_item_count: cart.item_count,
                cart_items: cartItems
              });
            })
            .catch(function() {});
        }, 500);
      }

      return origFetch.apply(this, arguments);
    };

    // Track checkout clicks
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (btn) {
        addVisitorToCart();
      }
    });
  }

  function setupTextInputTracking() {
    // Track when user finishes typing (on blur)
    document.addEventListener('blur', function(e) {
      var input = e.target;

      // Only track text inputs and textareas
      if (input.tagName !== 'INPUT' && input.tagName !== 'TEXTAREA') return;

      // Skip password and sensitive fields
      var skipTypes = ['password', 'hidden', 'submit', 'button', 'reset'];
      if (skipTypes.indexOf(input.type) > -1) return;

      // Skip empty inputs
      if (!input.value || input.value.trim() === '') return;

      // Get field identifier
      var fieldName = input.name || input.id || input.placeholder || input.type || 'unknown';

      // Mask email partially for privacy (optional)
      var fieldValue = input.value.trim();

      // Track specific valuable inputs
      var valuableFields = ['email', 'phone', 'promo', 'discount', 'coupon', 'code', 'search', 'q', 'query'];
      var isValuable = valuableFields.some(function(f) {
        return fieldName.toLowerCase().includes(f);
      });

      // Always track search queries
      if (input.type === 'search' || fieldName.toLowerCase().includes('search') || fieldName === 'q') {
        sendEvent('search_input', {
          search_term: fieldValue
        });
        return;
      }

      // Track email captures
      if (input.type === 'email' || fieldName.toLowerCase().includes('email')) {
        sendEvent('email_entered', {
          email: fieldValue,
          form_location: getFormLocation(input)
        });
        return;
      }

      // Track promo codes
      if (fieldName.toLowerCase().includes('promo') ||
          fieldName.toLowerCase().includes('discount') ||
          fieldName.toLowerCase().includes('coupon') ||
          fieldName.toLowerCase().includes('code')) {
        sendEvent('promo_code_entered', {
          promo_code: fieldValue
        });
        return;
      }

      // Track all other text inputs (optional - can be noisy)
      if (isValuable || input.tagName === 'TEXTAREA') {
        sendEvent('text_input', {
          field_name: fieldName,
          field_value: fieldValue.substring(0, 200), // Limit length
          field_type: input.type || 'textarea',
          form_location: getFormLocation(input)
        });
      }
    }, true);

    // Helper to identify where the form is
    function getFormLocation(input) {
       if (!input || !input.closest) return 'page';
      var form = input.closest('form');
      if (form) {
        return form.id || form.action || form.className.split(' ')[0] || 'unknown_form';
      }
      var section = input.closest('section, .popup, .modal, footer, header');
      if (section) {
        return section.id || section.className.split(' ')[0] || 'page';
      }
      return 'page';
    }
  }

  // ============================================
  // CART CONTENTS & UPDATES
  // ============================================

  function trackCartContents() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var items = cart.items.map(function(item) {
          return item.title + ' (x' + item.quantity + ')';
        }).join(', ');

        sendEvent('cart_contents', {
          cart_items: items,
          cart_value: (cart.total_price / 100).toFixed(2),
          cart_item_count: cart.item_count
        });
      })
      .catch(() => {});
  }

  function setupCartRemoveTracking() {
    document.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-cart-remove], .cart-remove, .remove-item, a[href*="/cart/change"]');
      if (removeBtn) {
        sendEvent('cart_item_removed');
      }
    });
  }

  // ============================================
  // BUTTON CLICK TRACKING (WITH TEXT)
  // ============================================

  function setupButtonClickTracking() {
    document.addEventListener('click', function(e) {
      var target = e.target.closest('button, a, [role="button"], input[type="submit"], input[type="button"]');

      if (!target) return;

      // Skip cart form buttons (already tracked by add_to_cart)
      if (target.closest('form[action*="/cart"]')) return;

      // Get button text
      var buttonText = '';

      if (target.tagName === 'INPUT') {
        buttonText = target.value || target.placeholder || '';
      } else {
        buttonText = target.innerText || target.textContent || '';
      }

      // Clean up the text
      buttonText = buttonText.trim().replace(/\s+/g, ' ').substring(0, 100);

      // Skip empty or icon-only buttons - use fallback
      if (!buttonText || buttonText.length < 2) {
        buttonText = target.getAttribute('aria-label') ||
                     target.getAttribute('title') ||
                     target.className.split(' ')[0] ||
                     'icon_button';
      }

      // Get button location
      var buttonLocation = 'page';
      if (target.closest('header, nav, .header')) buttonLocation = 'header';
      else if (target.closest('footer, .footer')) buttonLocation = 'footer';
      else if (target.closest('.cart-drawer, #cart-drawer, [data-cart-drawer]')) buttonLocation = 'cart_drawer';
      else if (target.closest('.popup, .modal, [data-popup]')) buttonLocation = 'popup';
      else if (target.closest('form')) buttonLocation = 'form';
      else if (target.closest('.product-card, [data-product-card]')) buttonLocation = 'product_card';
      else if (target.closest('.hero, [data-hero]')) buttonLocation = 'hero';

      sendEvent('button_click', {
        button_text: buttonText,
        button_href: (target.href || '').substring(0, 200),
        button_id: target.id || '',
        button_location: buttonLocation,
        element_type: target.tagName.toLowerCase(),
        element_class: target.className || ''
      });

    }, true);
  }

  // ============================================
  // NAVIGATION TRACKING
  // ============================================

  function setupMenuTracking() {
    document.addEventListener('click', function(e) {
      var menuLink = e.target.closest('nav a, .nav a, .menu a, .header a, [data-menu-item]');
      if (menuLink) {
        sendEvent('menu_click', {
          menu_item: menuLink.textContent.trim().substring(0, 50),
          menu_href: menuLink.href || ''
        });
      }
    });
  }

  function setupSearchTracking() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var searchInput = form.querySelector('input[type="search"], input[name="q"], input[name="query"]');
      if (searchInput) {
        sendEvent('search_query', {
          search_term: searchInput.value
        });
      }
    });

    if (getPageType() === 'search') {
      var params = new URLSearchParams(window.location.search);
      var query = params.get('q') || params.get('query') || '';
      var resultCount = document.querySelectorAll('.search-result, .product-card, [data-search-result]').length;

      sendEvent('search_results', {
        search_term: query,
        result_count: resultCount
      });
    }
  }

  function setupFilterTracking() {
    document.addEventListener('change', function(e) {
      var filter = e.target.closest('select[data-filter], input[data-filter], .filter select, .filter input');
      if (filter) {
        sendEvent('filter_applied', {
          filter_name: filter.name || filter.id || '',
          filter_value: filter.value
        });
      }
    });

    document.addEventListener('click', function(e) {
      var filterLink = e.target.closest('a[data-filter], .filter a, .facet a');
      if (filterLink) {
        sendEvent('filter_applied', {
          filter_value: filterLink.textContent.trim()
        });
      }
    });
  }

  function setupSortTracking() {
    document.addEventListener('change', function(e) {
      var sort = e.target.closest('select[name="sort_by"], select[data-sort], .sort-by select');
      if (sort) {
        sendEvent('sort_changed', {
          sort_value: sort.value
        });
      }
    });
  }

  function setupPaginationTracking() {
    document.addEventListener('click', function(e) {
      var pageLink = e.target.closest('.pagination a, [data-pagination] a, a[href*="page="]');
      if (pageLink) {
        sendEvent('pagination_click', {
          page_href: pageLink.href
        });
      }
    });
  }

  // ============================================
  // ENGAGEMENT TRACKING
  // ============================================

  function setupVideoTracking() {
    document.querySelectorAll('video').forEach(function(video) {
      video.addEventListener('play', function() {
        sendEvent('video_play', {
          video_src: video.src || video.currentSrc,
          video_duration: video.duration
        });
      });

      video.addEventListener('pause', function() {
        sendEvent('video_pause', {
          video_src: video.src || video.currentSrc,
          video_current_time: video.currentTime
        });
      });

      video.addEventListener('ended', function() {
        sendEvent('video_complete', {
          video_src: video.src || video.currentSrc
        });
      });
    });

    document.querySelectorAll('iframe[src*="youtube"]').forEach(function(iframe, index) {
      sendEvent('video_embed_view', {
        video_type: 'youtube',
        video_index: index
      });
    });
  }

  function setupPinchZoomTracking() {
    var lastPinchTime = 0;

    document.addEventListener('touchmove', function(e) {
      if (e.touches.length !== 2) return;

      var now = Date.now();
      if (now - lastPinchTime < 2000) return;
      lastPinchTime = now;

      var t1 = e.touches[0];
      var t2 = e.touches[1];
      var midX = (t1.clientX + t2.clientX) / 2;
      var midY = (t1.clientY + t2.clientY) / 2;

      var target = document.elementFromPoint(midX, midY);
      if (!target) return;

      var img = target.closest('img') || target.querySelector('img');
      var section = target.closest('section, [data-section], .shopify-section');

      sendEvent('pinch_zoom', {
        zoom_target: img ? img.alt || img.src.split('/').pop() : '',
        zoom_element: target.tagName.toLowerCase(),
        zoom_class: (target.className || '').toString().substring(0, 100),
        zoom_section: section ? (section.id || section.className.split(' ')[0]) : '',
        zoom_x: Math.round(midX),
        zoom_y: Math.round(midY + window.scrollY)
      });
    }, { passive: true });
  }

  function setupImageZoomTracking() {
    document.addEventListener('click', function(e) {
      var zoomTarget = e.target.closest('[data-zoom], .product-image, .gallery-image, img[data-enlargable]');
      if (zoomTarget) {
        sendEvent('image_zoom', {
          image_src: zoomTarget.src || zoomTarget.querySelector('img')?.src || ''
        });
      }
    });
  }

  function setupTabTracking() {
    document.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-tab], .tab, [role="tab"]');
      if (tab) {
        sendEvent('tab_switch', {
          tab_name: tab.textContent.trim().substring(0, 50)
        });
      }
    });
  }

  function setupAccordionTracking() {
    document.addEventListener('click', function(e) {
      var accordion = e.target.closest('[data-accordion], .accordion-header, .collapsible-header, details summary');
      if (accordion) {
        sendEvent('accordion_open', {
          accordion_title: accordion.textContent.trim().substring(0, 100)
        });
      }
    });
  }

  function setupFaqTracking() {
    document.addEventListener('click', function(e) {
      var faq = e.target.closest('.faq-question, [data-faq], .faq-item');
      if (faq) {
        sendEvent('faq_expand', {
          faq_question: faq.textContent.trim().substring(0, 150)
        });
      }
    });
  }

  // ============================================
  // FORM TRACKING
  // ============================================

  function setupFormTracking() {
    var formStarted = {};

    document.addEventListener('focus', function(e) {
      var input = e.target;
       if (!input || !input.closest) return;
      var form = input.closest('form');
      if (!form) return;

      var formId = form.id || form.action || 'unknown_form';

      if (!formStarted[formId]) {
        formStarted[formId] = true;
        sendEvent('form_start', {
          form_id: formId,
          form_action: form.action || ''
        });
      }

      sendEvent('form_field_focus', {
        form_id: formId,
        field_name: input.name || input.id || '',
        field_type: input.type || input.tagName.toLowerCase()
      });
    }, true);

    document.addEventListener('blur', function(e) {
      var input = e.target;
       if (!input || !input.closest) return;
      var form = input.closest('form');
      if (!form) return;

      var formId = form.id || form.action || 'unknown_form';

      sendEvent('form_field_blur', {
        form_id: formId,
        field_name: input.name || input.id || '',
        field_filled: !!input.value
      });
    }, true);

    document.addEventListener('submit', function(e) {
      var form = e.target;
      var formId = form.id || form.action || 'unknown_form';

      if (form.action && form.action.includes('/cart')) return;

      sendEvent('form_submit', {
        form_id: formId,
        form_action: form.action || ''
      });
    });

    document.addEventListener('invalid', function(e) {
      var input = e.target;
      if (!input || !input.closest) return;
      var form = input.closest('form');
      var formId = form ? (form.id || form.action || 'unknown_form') : 'unknown';

      sendEvent('form_error', {
        form_id: formId,
        field_name: input.name || input.id || '',
        error_message: input.validationMessage
      });
    }, true);
  }

  function setupNewsletterTracking() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var emailInput = form.querySelector('input[type="email"]');
      var isNewsletter = form.classList.contains('newsletter') ||
                         form.id.includes('newsletter') ||
                         form.action.includes('newsletter') ||
                         form.action.includes('subscribe');

      if (emailInput && isNewsletter) {
        sendEvent('newsletter_signup', {
          form_id: form.id || form.action
        });
      }
    });
  }

  // ============================================
  // PRODUCT INTERACTION TRACKING
  // ============================================

  function setupVariantTracking() {
    document.addEventListener('change', function(e) {
      var select = e.target;

      if (select.name && (select.name.includes('option') || select.name.includes('variant'))) {
        sendEvent('variant_selected', {
          variant_type: select.name,
          variant_value: select.value,
          ...getProductInfo()
        });
      }

      if (select.name && select.name.toLowerCase().includes('size')) {
        sendEvent('size_selected', {
          size_value: select.value,
          ...getProductInfo()
        });
      }

      if (select.name && select.name.toLowerCase().includes('color')) {
        sendEvent('color_selected', {
          color_value: select.value,
          ...getProductInfo()
        });
      }
    });

    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-option-value], .swatch, .color-swatch, .size-swatch');
      if (swatch) {
        var value = swatch.dataset.optionValue || swatch.textContent.trim();
        sendEvent('variant_selected', {
          variant_value: value,
          ...getProductInfo()
        });
      }
    });
  }

  function setupQuantityTracking() {
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (input.name === 'quantity' || input.classList.contains('quantity-input')) {
        sendEvent('quantity_changed', {
          quantity: input.value,
          ...getProductInfo()
        });
      }
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quantity-plus], [data-quantity-minus], .quantity-plus, .quantity-minus');
      if (btn) {
        setTimeout(function() {
          var input = btn.closest('.quantity')?.querySelector('input');
          sendEvent('quantity_changed', {
            quantity: input ? input.value : 'unknown',
            ...getProductInfo()
          });
        }, 100);
      }
    });
  }

  function setupReviewsTracking() {
    document.addEventListener('click', function(e) {
      var reviewsLink = e.target.closest('a[href*="#reviews"], a[href*="reviews"], .reviews-link, [data-reviews]');
      if (reviewsLink) {
        sendEvent('reviews_viewed', getProductInfo());
      }
    });

    var reviewsSection = document.querySelector('#reviews, .reviews-section, [data-reviews-section]');
    if (reviewsSection) {
      var reviewsObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            sendEvent('reviews_viewed', getProductInfo());
            reviewsObserver.disconnect();
          }
        });
      }, { threshold: 0.5 });
      reviewsObserver.observe(reviewsSection);
    }
  }

  function setupWishlistTracking() {
    document.addEventListener('click', function(e) {
      var wishlistBtn = e.target.closest('[data-wishlist], .wishlist-btn, .add-to-wishlist, .favorite-btn');
      if (wishlistBtn) {
        sendEvent('wishlist_add', getProductInfo());
      }
    });
  }

  // ============================================
  // PROMO CODE TRACKING
  // ============================================

  function setupPromoCodeTracking() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var promoInput = form.querySelector('input[name="discount"], input[name="promo"], input[name="coupon"]');
      if (promoInput && promoInput.value) {
        sendEvent('promo_code_applied', {
          promo_code: promoInput.value
        });
      }
    });

    document.addEventListener('click', function(e) {
      var promoBtn = e.target.closest('[data-apply-discount], .apply-promo, .apply-coupon');
      if (promoBtn) {
        var input = promoBtn.closest('form')?.querySelector('input[name="discount"], input[name="promo"]');
        if (input && input.value) {
          sendEvent('promo_code_applied', {
            promo_code: input.value
          });
        }
      }
    });
  }

  // ============================================
  // SOCIAL TRACKING
  // ============================================

  function setupSocialTracking() {
    document.addEventListener('click', function(e) {
      var socialLink = e.target.closest('a[href*="facebook.com/share"], a[href*="twitter.com/intent"], a[href*="pinterest.com/pin"], a[href*="linkedin.com/share"], [data-social-share]');
      if (socialLink) {
        var platform = 'unknown';
        var href = socialLink.href || '';
        if (href.includes('facebook')) platform = 'facebook';
        else if (href.includes('twitter')) platform = 'twitter';
        else if (href.includes('pinterest')) platform = 'pinterest';
        else if (href.includes('linkedin')) platform = 'linkedin';

        sendEvent('social_share', {
          platform: platform,
          shared_url: window.location.href
        });
      }

      var socialFollow = e.target.closest('a[href*="facebook.com/"], a[href*="instagram.com/"], a[href*="twitter.com/"], a[href*="tiktok.com/"], a[href*="youtube.com/"]');
      if (socialFollow && !socialFollow.href.includes('/share')) {
        var platform = 'unknown';
        var href = socialFollow.href || '';
        if (href.includes('facebook')) platform = 'facebook';
        else if (href.includes('instagram')) platform = 'instagram';
        else if (href.includes('twitter')) platform = 'twitter';
        else if (href.includes('tiktok')) platform = 'tiktok';
        else if (href.includes('youtube')) platform = 'youtube';

        sendEvent('social_click', {
          platform: platform
        });
      }
    });
  }

  function setupReviewSubmitTracking() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.classList.contains('review-form') ||
          form.id.includes('review') ||
          form.action.includes('review')) {
        sendEvent('review_submitted', getProductInfo());
      }
    });
  }

  function setupReferralTracking() {
    document.addEventListener('click', function(e) {
      var referBtn = e.target.closest('[data-refer], .refer-friend, .referral-btn');
      if (referBtn) {
        sendEvent('refer_friend');
      }
    });

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.classList.contains('referral-form') || form.action.includes('refer')) {
        sendEvent('refer_friend', {
          referral_method: 'form'
        });
      }
    });
  }

  // ============================================
  // ERROR TRACKING
  // ============================================

  function setupErrorTracking() {
    window.addEventListener('error', function(e) {
      sendEvent('page_error', {
        error_message: e.message,
        error_source: e.filename,
        error_line: e.lineno
      });
    });
  }

  // ============================================
  // PERFORMANCE TRACKING
  // ============================================

  function trackPageLoadTime() {
    window.addEventListener('load', function() {
      requestAnimationFrame(function() {
        setTimeout(function() {
          var entry = performance.getEntriesByType('navigation')[0];
          if (!entry) return;

          var loadTime = Math.round(entry.loadEventEnd);
          var domReady = Math.round(entry.domContentLoadedEventEnd);

          if (loadTime <= 0) return;

          sendEvent('page_load_time', {
            load_time_ms: loadTime,
            dom_ready_ms: domReady
          });

          if (loadTime > 5000) {
            sendEvent('slow_page', {
              load_time_ms: loadTime
            });
          }
        }, 0);
      });
    });
  }

  function setupRageClickTracking() {
    var clicks = [];
    var rageThreshold = 3;
    var rageWindow = 1000;

    document.addEventListener('click', function(e) {
      var now = Date.now();
      clicks.push({ time: now, x: e.clientX, y: e.clientY });

      clicks = clicks.filter(function(c) {
        return now - c.time < rageWindow;
      });

      if (clicks.length >= rageThreshold) {
        var firstClick = clicks[0];
        var allNearby = clicks.every(function(c) {
          return Math.abs(c.x - firstClick.x) < 50 && Math.abs(c.y - firstClick.y) < 50;
        });

        if (allNearby) {
          sendEvent('rage_click', {
            click_count: clicks.length,
            click_x: e.clientX,
            click_y: e.clientY,
            target_element: e.target.tagName + (e.target.id ? '#' + e.target.id : '')
          });
          clicks = [];
        }
      }
    });
  }

  // ============================================
  // QUIZ TRACKING
  // ============================================

  function setupQuizTracking() {
    document.addEventListener('click', function(e) {
      var quizStart = e.target.closest('[data-quiz-start], .quiz-start, .start-quiz');
      if (quizStart) {
        sendEvent('quiz_started');
      }
    });

    document.addEventListener('click', function(e) {
      var quizAnswer = e.target.closest('[data-quiz-answer], .quiz-answer, .quiz-option');
      if (quizAnswer) {
        var questionEl = quizAnswer.closest('[data-quiz-question], .quiz-question');
        sendEvent('quiz_question_answered', {
          question: questionEl ? questionEl.dataset.quizQuestion || '' : '',
          answer: quizAnswer.textContent.trim().substring(0, 100)
        });
      }
    });

    var quizResultsObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 &&
              (node.classList.contains('quiz-results') ||
               node.classList.contains('quiz-complete') ||
               node.querySelector('.quiz-results'))) {
            sendEvent('quiz_completed');
          }
        });
      });
    });

    quizResultsObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ============================================
  // POPUP TRACKING
  // ============================================

  function setupPopupTracking() {
    var popupObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var isPopup = node.classList.contains('popup') ||
                         node.classList.contains('modal') ||
                         node.classList.contains('overlay') ||
                         (node.id && node.id.includes('popup')) ||
                         (node.id && node.id.includes('modal'));

            if (isPopup) {
              sendEvent('popup_shown', {
                popup_id: node.id || node.className.substring(0, 50)
              });

              node.addEventListener('click', function(e) {
                var closeBtn = e.target.closest('.close, .popup-close, .modal-close, [data-close]');
                if (closeBtn) {
                  sendEvent('popup_closed', {
                    popup_id: node.id || node.className.substring(0, 50)
                  });
                }
              });
            }
          }
        });
      });
    });

    popupObserver.observe(document.body, { childList: true, subtree: true });
  }

  function setupExitIntentTracking() {
    var exitIntentFired = false;

    document.addEventListener('mouseout', function(e) {
      if (e.clientY < 10 && !exitIntentFired) {
        exitIntentFired = true;
        sendEvent('exit_intent_triggered');
      }
    });
  }

  // ============================================
  // MOBILE TRACKING
  // ============================================

  function setupMobileTracking() {
    if (getDeviceType() !== 'Mobile' && getDeviceType() !== 'Tablet') return;

    var touchStart = null;

    document.addEventListener('touchstart', function(e) {
      touchStart = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
        time: Date.now()
      };
    });

    document.addEventListener('touchend', function(e) {
      if (!touchStart) return;

      var touchEnd = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      };

      var diffX = touchEnd.x - touchStart.x;
      var diffY = touchEnd.y - touchStart.y;
      var timeDiff = Date.now() - touchStart.time;

      if (timeDiff > 500) return;

      if (Math.abs(diffX) > 100 && Math.abs(diffY) < 50) {
        if (diffX > 0) {
          sendEvent('swipe_right');
        } else {
          sendEvent('swipe_left');
        }
      }
    });

    window.addEventListener('orientationchange', function() {
      sendEvent('orientation_change', {
        orientation: screen.orientation ? screen.orientation.type :
                    (window.innerHeight > window.innerWidth ? 'portrait' : 'landscape')
      });
    });

    var lastTouchCount = 0;
    document.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2 && lastTouchCount !== 2) {
        sendEvent('pinch_zoom');
      }
      lastTouchCount = e.touches.length;
    });

    document.addEventListener('touchend', function() {
      lastTouchCount = 0;
    });
  }

  // ============================================
  // SCROLL DEPTH
  // ============================================

  function setupScrollTracking() {
    const milestones = [25, 50, 75, 90];
    const tracked = [];

    window.addEventListener('scroll', function() {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;

      const scrollPercent = Math.round((window.scrollY / scrollHeight) * 100);

      milestones.forEach(function(milestone) {
        if (scrollPercent >= milestone && tracked.indexOf(milestone) === -1) {
          tracked.push(milestone);
          sendEvent('scroll_depth', { scroll_depth: milestone + '%' });
        }
      });
    });
  }

  // ============================================
  // TIME ON PAGE
  // ============================================

  function setupTimeTracking() {
    const milestones = [30, 60, 120, 300];
    const tracked = [];
    const startTime = Date.now();

    setInterval(function() {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);

      milestones.forEach(function(milestone) {
        if (elapsed >= milestone && tracked.indexOf(milestone) === -1) {
          tracked.push(milestone);
          sendEvent('time_on_page', { time_on_page: milestone });
        }
      });
    }, 5000);
  }

  // ============================================
  // SESSION END
  // ============================================

  function setupEndSessionTracking() {
    var sessionStartTime = parseInt(sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'session_start_time')) || Date.now();

    window.addEventListener('beforeunload', function() {
      var sessionDuration = Math.floor((Date.now() - sessionStartTime) / 1000);
      var pageCount = sessionStorage.getItem(CONFIG.STORAGE_PREFIX + 'page_count') || 1;

      var payload = {
        timestamp: new Date().toISOString(),
        event_type: 'session_end',
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        session_duration_seconds: sessionDuration,
        pages_viewed: parseInt(pageCount),
        exit_page: window.location.href
      };

      navigator.sendBeacon(CONFIG.WEBHOOK_URL, JSON.stringify(payload));
    });
  }

  // ============================================
  // PUBLIC API
  // ============================================

  window.MburTracker = {
    trackSampleSelection: function(scentName) {
      sendEvent('sample_selection', { scent_name: scentName });
    },

    trackSampleRequest: function(scentsArray) {
      const scents = Array.isArray(scentsArray) ? scentsArray.join(', ') : scentsArray;
      sendEvent('sample_request', { scents_selected: scents });
    },

    trackEmail: function(email) {
      sendEvent('email_captured', { email: email });
    },

    trackCustomEvent: function(eventType, data) {
      sendEvent(eventType, data);
    },

    getVisitorId: function() {
      return getVisitorId();
    },

    getSessionId: function() {
      return getSessionId();
    }
  };

  // ============================================
  // INITIALIZE
  // ============================================

  function init() {
    log('Initializing complete tracker');

    trackSessionStart();

    setTimeout(function() {
      trackPageView();
      trackProductView();
      trackCollectionView();
      trackBlogRead();
      trackCartView();
      trackCheckoutInitiated();
      track404Page();

      setupAddToCartTracking();
      setupCartRemoveTracking();
      if (getPageType() === 'cart') trackCartContents();


      setupButtonClickTracking();
      setupTextInputTracking();
      setupMenuTracking();
      setupSearchTracking();
      setupFilterTracking();
      setupSortTracking();
      setupPaginationTracking();

      setupVideoTracking();
      setupImageZoomTracking();
      setupPinchZoomTracking();
      setupTabTracking();
      setupAccordionTracking();
      setupFaqTracking();

      setupFormTracking();
      setupNewsletterTracking();

      setupVariantTracking();
      setupQuantityTracking();
      setupReviewsTracking();
      setupWishlistTracking();
      setupPromoCodeTracking();

      setupSocialTracking();
      setupReviewSubmitTracking();
      setupReferralTracking();

      setupErrorTracking();
      trackPageLoadTime();
      setupRageClickTracking();

      setupQuizTracking();
      setupPopupTracking();
      setupExitIntentTracking();

      setupMobileTracking();

      setupScrollTracking();
      setupTimeTracking();

      setupEndSessionTracking();

      log('Complete tracker initialized - 70+ events active');
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
